import * as t from 'io-ts';

/*
 * Runtime types.
 */

const RConversationMetaDirty = t.readonly(
  t.intersection([
    t.type({
      conversationId: t.Integer,
    }),
    t.partial({
      matchedQueries: t.readonlyArray(t.string),
    }),
  ]),
);

/*
 * Types.
 */

export interface ConversationMetaModel extends t.TypeOf<typeof RConversationMetaDirty> {}

export const RConversationMeta = t.clean<ConversationMetaModel>(RConversationMetaDirty as any);

/*
 * Type guards.
 */

export function hasMatchedQueriesConversationMetaModel(
  conversationMeta: ConversationMetaModel,
): conversationMeta is ConversationMetaModel & {matchedQueries: Array<string>} {
  return Array.isArray(conversationMeta.matchedQueries) && conversationMeta.matchedQueries.length > 0;
}

/*
 * IO methods.
 */

/* eslint no-underscore-dangle: 0 */
export function parseConversationMeta(src: any) {
  return {
    conversationId: src.id,
    matchedQueries: (src._meta && src._meta.matched_queries) || undefined,
  };
}
